import React, { useMemo } from "react";
import useForm from "../../../Hooks/useForm";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import { FORM_PRODUCTO } from "../../../Constants/Admin";
import { FormProductoScheme } from "../../../Models/Schemas/form-producto";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import Input from "../../Elements/Input/Input";
import Button from "../../Elements/Button/Button";
import { Select, TextArea, Switch } from "./Campos";

const FormProducto = ({ producto, seccionIdInicial, cerrar }) => {
  const showToast = useToast();
  const { secciones, guardarProducto, guardando } = useStore();

  const initialValues = useMemo(
    () =>
      producto
        ? {
            seccionId: producto.seccionId,
            nombre: producto.nombre || "",
            descripcion: producto.descripcion || "",
            precio: producto.precio == null ? "" : String(producto.precio),
            disponible: producto.disponible !== false,
          }
        : { ...FORM_PRODUCTO, seccionId: seccionIdInicial || "" },
    [producto, seccionIdInicial]
  );

  const { values, errors, touched, handleChange, handleBlur, setFieldValue, isValid } =
    useForm(initialValues, FormProductoScheme);

  // Opciones agrupadas: "Para Acompañar › Alitas"
  const opcionesSeccion = useMemo(() => {
    const nombre = (id) => secciones.find((s) => s.seccionId === id)?.nombre;
    return [
      { value: "", label: "Elige una sección…" },
      ...secciones.map((s) => ({
        value: s.seccionId,
        label: s.padreId ? `${nombre(s.padreId) || s.padreId} › ${s.nombre}` : s.nombre,
      })),
    ];
  }, [secciones]);

  const err = (key) => setErrorFormSimpleUtil(errors, touched, key);

  const submit = async () => {
    if (!isValid) return;
    const body = {
      seccionId: values.seccionId,
      nombre: values.nombre.trim(),
      descripcion: values.descripcion.trim(),
      precio: values.precio === "" ? null : Number(values.precio),
      disponible: values.disponible,
    };
    const r = await guardarProducto(body, producto?.productoId);
    showToast(r.ok ? "success" : "error", r.ok ? (producto ? "Producto actualizado ✅" : "Producto agregado 🍕") : r.message);
    if (r.ok) cerrar();
  };

  return (
    <form
      className="pp-form"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <Select
        label="Sección"
        value={values.seccionId}
        onChange={(v) => setFieldValue("seccionId", v)}
        opciones={opcionesSeccion}
        error={errors.seccionId && touched.seccionId ? errors.seccionId : undefined}
      />
      <Input
        label="Nombre"
        value={values.nombre}
        placeholder="Ej. Pepperoni"
        onChange={handleChange("nombre")}
        onBlur={handleBlur("nombre")}
        error={err("nombre")}
        maxLength={80}
      />
      <TextArea
        label="Descripción / ingredientes"
        value={values.descripcion}
        placeholder="Ej. Pepperoni y queso"
        onChange={(v) => setFieldValue("descripcion", v)}
        error={err("descripcion")}
      />
      <Input
        label="Precio"
        value={values.precio}
        placeholder="Ej. 135"
        inputMode="decimal"
        onChange={handleChange("precio")}
        onBlur={handleBlur("precio")}
        error={err("precio")}
        maxLength={8}
      />
      <p className="pp-ayuda pp-ayuda-arriba">
        Déjalo vacío si el precio lo marca la sección (ej. pizzas por tamaño, sabores de alitas).
      </p>
      <Switch
        label={values.disponible ? "Disponible" : "Agotado (se muestra tachado)"}
        checked={values.disponible}
        onChange={(v) => setFieldValue("disponible", v)}
      />

      <div className="pp-form-acciones">
        <Button text="Cancelar" color="gray" action={cerrar} padding />
        <Button
          text={guardando ? "Guardando…" : "Guardar"}
          color="red"
          fill
          action={submit}
          disabled={!isValid || guardando}
          padding
        />
      </div>
    </form>
  );
};

export default FormProducto;
